import { useMemo } from 'react';
export const useDeviceDetect = () => useMemo(() => {
  var _navigator, _navigator2;
  return {
    isMobile: !!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)),
    isFirefox: !!((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2 = _navigator2.userAgent) !== null && _navigator2 !== void 0 && (_navigator2 = _navigator2.toLowerCase()) !== null && _navigator2 !== void 0 && _navigator2.includes('firefox'))
  };
}, []);